export const VIEW_MODE_MAP = {
  EDIT: "edit",
  VIEW: "view",
  CREATE: "create",
}

export const REQUIRED_FIELDS = ["name"];

export const REQUIRED_CONFIG_FIELDS = [
  "clients",
  "action",
];

export const OPTIONAL_CONFIG_FIELDS = [
  "users",
  "groups",
];

export const ACTION_OPTIONS = [
  {
    id: "ASSIGN",
    tKey: "wam.action_options.assign",
  },
  {
    id: "UNASSIGN",
    tKey: "wam.action_options.unassign",
  },
  {
    id: "PROVIDE_ACCESS",
    tKey: "wam.action_options.provide_access",
  },
  {
    id: "REVOKE_ACCESS",
    tKey: "wam.action_options.revoke_access",
  },
];

export const MULTI_FIELD_TYPE_NAMES = [
  "Multi select",
  "Checkbox",
];
